import { render, staticRenderFns } from "./Resumen.vue?vue&type=template&id=1b53a6a3&scoped=true"
import script from "./Resumen.vue?vue&type=script&lang=js"
export * from "./Resumen.vue?vue&type=script&lang=js"
import style0 from "./Resumen.vue?vue&type=style&index=0&id=1b53a6a3&prod&scoped=true&lang=css"
import style1 from "~/assets/style/toolbar-panels.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b53a6a3",
  null
  
)

export default component.exports